module.exports = require("github:mahnunchik/markerclustererplus@2.1.4/src/markerclusterer.js");